import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

import { SnIncidentMedia } from '@lib/api/entities';

@Component({
  selector: 'sn-incident-media-list-item',
  templateUrl: './incident-media-list-item.component.html',
  styleUrls: ['./incident-media-list-item.component.scss'],
})
export class IncidentMediaListItemComponent implements OnInit {
  @Input()
  public item: SnIncidentMedia;

  @Output()
  public readonly fileDeleted = new EventEmitter<SnIncidentMedia>();

  public imageSrc: string;
  public title: string;
  public fileUrl: string;
  public showIcon: boolean = false;

  constructor() {}

  public ngOnInit(): void {
    this._onInit();
  }

  public onError(): void {
    this.showIcon = true;
  }

  public download(): void {
    const downloadLink = document.createElement('a');
    downloadLink.setAttribute('download', this.title);
    downloadLink.setAttribute('href', this.item.url);
    downloadLink.click();
  }

  public deleteItem(): void {
    this.fileDeleted.emit(this.item);
  }

  private _onInit(): void {
    this.imageSrc = this.item.url;
    const url: string = this.imageSrc;
    const fields = url.split('?')[0].split('/');
    this.title = fields[6];
  }
}
